import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Style from './styles';
import * as Icon from './icons';
export default function Toasts({ position, messages, closeMessage }) {
    function getIcon(type) {
        if (type === 'success')
            return _jsx(Icon.Success, {});
        if (type === 'warning')
            return _jsx(Icon.Warning, {});
        if (type === 'error')
            return _jsx(Icon.Error, {});
        return _jsx(Icon.Info, {});
    }
    return (_jsx(Style.ToastContainer, Object.assign({ position: position }, { children: messages.map(({ id, message, type, duration }) => (_jsxs(Style.Toast, Object.assign({ messageType: type, duration: duration, "aria-label": toastAriaLabel(type) }, { children: [getIcon(type), _jsx(Style.Message, Object.assign({ messageType: type }, { children: message })), _jsx(Style.CloseButton, Object.assign({ "aria-label": "Close toast message", type: "button", messageType: type, onClick: () => closeMessage(id, position) }, { children: _jsx(Icon.Close, {}) })), _jsx(Style.ProgressBar, { messageType: type, duration: duration })] }), id))) })));
}
function toastAriaLabel(type) {
    if (type === 'success')
        return 'Toast success message';
    if (type === 'info')
        return 'Toast info message';
    if (type === 'warning')
        return 'Toast warning message';
    return 'Toast error message';
}
